export function formatDateLocal(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function getPresetRange(preset) {
  const today = new Date();
  if (preset === "month") {
    return { desde: formatDateLocal(startOfMonth(today)), hasta: formatDateLocal(today) };
  }
  if (preset === "last3") {
    return { desde: formatDateLocal(new Date(today.getFullYear(), today.getMonth() - 2, 1)), hasta: formatDateLocal(today) };
  }
  if (preset === "year") {
    return { desde: formatDateLocal(new Date(today.getFullYear(), 0, 1)), hasta: formatDateLocal(today) };
  }
  return { desde: formatDateLocal(startOfMonth(today)), hasta: formatDateLocal(today) };
}
